import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { c as classNames } from '../index_orig/index-chunk.esm.js';
import { b as EGDSButton, a as EGDSButtonTheme } from '../button/index-chunk.esm.js';

class EGDSPagingButton extends React.Component {
    static displayName = 'EGDSPagingButton';
    render() {
        const { icon, iconId, iconTitle, pagingOverlay, children, ...props } = this.props;
        const cssClassNames = classNames(props.className, `${EGDSButton.baseClassName}-paging`, {
            [`${EGDSButton.baseClassName}-paging-overlay`]: pagingOverlay || props.theme === EGDSButtonTheme.TRANSPARENT,
        });
        return (jsxs(EGDSButton, { ...props, className: cssClassNames, children: [icon && jsx(EGDSIcon, { name: icon, id: iconId, title: iconTitle }), children || null] }));
    }
}

class EGDSPagingNextButton extends React.Component {
    static displayName = 'EGDSPagingNextButton';
    render() {
        return jsx(EGDSPagingButton, { ...this.props, icon: "chevron_right" });
    }
}

class EGDSPagingPrevButton extends React.Component {
    static displayName = 'EGDSPagingPrevButton';
    render() {
        return jsx(EGDSPagingButton, { ...this.props, icon: "chevron_left" });
    }
}

export { EGDSPagingButton as E, EGDSPagingNextButton as a, EGDSPagingPrevButton as b };
//# sourceMappingURL=index-chunk.esm.js.map
